module.exports = __webpack_public_path__ + "img/aiGLM.e5da8368.png";